<!--
 * @Author: zhonghao
 * @Date: 2023-07-05 22:10:25
-->
<template>
  <div class="index-details">
    <div class="index-title">Carto 远程服务声明</div>
    <div class="index-con" v-html="detailsConten">
    </div>
    <div class="submit" @click="handleClick"> 关闭 </div>
  </div>
</template>
<script>

export default {
  name: 'wineDetails',
  data () {
    return {
      detailsConten: {}
    }
  },
  created () {
    this.detailsConten = `<p style="white-space: normal;"><span style="font-family: Tahoma, sans-serif;">Carto</span>远程服务声明：</p><p style="white-space: normal;"><span style="font-family: Tahoma, sans-serif;">&nbsp;</span></p><p style="white-space: normal;"><span style="font-family: Tahoma, sans-serif;">&nbsp;</span></p><p style="white-space: normal;"><span style="font-family: 微软雅黑, sans-serif;">为了更好地为临床医生介绍强生电生理产品的使用注意事项，强生医疗将通过电生理产品部的</span><span style="font-family: 微软雅黑, sans-serif;">临床</span><span style="font-family: 微软雅黑, sans-serif;">技术专员和专业教育团队，共同为客户提供技术支持。</span><span style="font-family: 微软雅黑, sans-serif;">临床</span><span style="font-family: 微软雅黑, sans-serif;">技术专员在手术室跟台过程中，将根据需求，选择性启用远程视频装置，联动强生的专业教育团队，远程实时地为</span><span style="font-family: 微软雅黑, sans-serif;">临床</span><span style="font-family: 微软雅黑, sans-serif;">技术专员提供技术指导。</span></p><p style="white-space: normal;"><span style="font-family: 微软雅黑, sans-serif;">&nbsp;</span></p><p style="white-space: normal;"><span style="font-family: 微软雅黑, sans-serif;">强生医疗的</span><span style="font-family: 微软雅黑, sans-serif;">临床</span><span style="font-family: 微软雅黑, sans-serif;">技术专员和专业教育团队均已接受公司专业培训并取得培训合格证明，能够熟练掌握术中所用器械的基本性能和操作方法。在</span><span style="font-family: 微软雅黑, sans-serif;">临床</span><span style="font-family: 微软雅黑, sans-serif;">技术专员手术室跟台和专业教育团队远程指导过程中，我司人员会充分尊重病人的隐私，遵守医院对于手术室的相关规定和要求，并高度重视手术室的无菌操作。在远程指导过程中，的相关视频传输装置，出厂已经设置为无法进行录制、截取和存储，确保所有的内容都以点对点直播的形式传输且无法录制</span><span style="font-family: 微软雅黑, sans-serif;">。</span><span style="font-family: 微软雅黑, sans-serif;">此外，所有的远程指导操作只针对</span><span style="font-family: 微软雅黑, sans-serif;">Carto</span><span style="font-family: 微软雅黑, sans-serif;">系统</span><span style="font-family: 微软雅黑, sans-serif;">。</span></p><p style="white-space: normal;"><span style="font-family: Tahoma, sans-serif;">&nbsp;</span></p><p style="white-space: normal;"><span style="font-family: 微软雅黑, sans-serif;">为实现上述远程技术支持之目的，</span><span style="font-family: 微软雅黑, sans-serif;">您同意我们收集和使用您进行电生理手术操作时的</span><span style="font-family: 微软雅黑, sans-serif;">Carto</span><span style="font-family: 微软雅黑, sans-serif;">屏幕信息</span><span style="font-family: 微软雅黑, sans-serif;">（</span><span style="font-family: 微软雅黑, sans-serif;">包含三维心腔模型</span><span style="font-family: 微软雅黑, sans-serif;">，</span><span style="font-family: 微软雅黑, sans-serif;">心电生理信息及设置显示数据</span><span style="font-family: 微软雅黑, sans-serif;">）</span><span style="font-family: 微软雅黑, sans-serif;">。您确认数据中不包含病历数据及患者个人信息（包括但不限于：患者的姓名、电话、住址、病例编号以及其他单独或通过与其他数据/信息相结合能够识别患者个人身份的信息）。如有，您将确保相关数据已经适当匿名化处理。您进一步确认，数据的提供已获得医院的适当授权和患者的知情同意（如适用）。</span></p><p style="white-space: normal;"><br/> </p><p style="white-space: normal;">本人签署本文件，确认我已知晓并同意上述内容。</p><p style="white-space: normal;">&nbsp;</p><p style="white-space: normal;"><span style="font-size: 12px;">*</span><span style="font-size: 12px;">重要提示：器械产品使用前，请临床医生仔细阅读与产品一同提供的使用说明书中列出的适应症、禁忌症、副作用、建议程序、警告和注意事项等。强生医疗的临床技术专员和专业教育团队的远程指导员对于器械产品基本性能和操作方法的介绍，并不能替代临床判断和实践，请临床医生遵循常规临床实践独立做出判断。</span></p><p style="white-space: normal;"><span style="font-size: 12px;">*</span><span style="font-size: 12px;">医务人员的电子邮箱地址仅用于向签署人提供本表格的副本，不另作他用。</span></p>`
  },
  methods: {
    handleClick() {
      this.$router.back()
    }
  }
}
</script>
<style lang="less" scoped>
.index-details {
  width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  padding: 15px 20px 30px;
  box-sizing: border-box;

  .index-title {
    margin-bottom: 16px;
    text-align: center;
    font-size: 18px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #222528;
  }

  .index-date {
    font-size: 12px;
    color: #999999;
    font-weight: 400;
    margin-bottom: 30px;
  }

  .index-con {
    margin-bottom: 20px;
    color: #45555f;
    font-size: 13px;
    line-height: 1.5;
    overflow: hidden;
    width: 100%;
    word-break: break-word;
    font-family: BlinkMacSystemFont, 'Helvetica Neue', 'Source Han Sans CN, Source Han Sans CN', 'Hiragino Sans GB', Arial, sans-serif;
  }
  .submit {
    width: 150px;
    height: 30px;
    line-height: 30px;
    background: -webkit-linear-gradient(top, #ff922d 0%, #ff601f 100%);
    background: linear-gradient(180deg, #ff922d 0%, #ff601f 100%);
    border-radius: 15px;
    margin: auto;
    font-size: 16px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    text-align: center;
  }
}</style>



// WEBPACK FOOTER //
// src/views/singlePage.vue